const AppConfigDefs = {
    app: {
        abreviatura: "SIC",
        nome: "Sistema de Inteligência Comercial",
        empresa: "Collabe Consultoria Estratégica",
        footer: "Collabe Consultoria Estratégica - 2025"
    },
    login: {
        logo: {
            ligth: 'layout/collabe/images/logo-light.png',
            dark: 'layout/collabe/images/logo-dark.png',
            style: 'height: 60px;'
        },
        logoname: {
            ligth: 'layout/collabe/images/logo-nome-light.png',
            dark: 'layout/collabe/images/logo-nome-dark.png',
            style: 'width: 180px;'
        }
    },
    topbar: {
        logo: {
            ligth: 'layout/collabe/images/logo-light.png',
            dark: 'layout/collabe/images/logo-dark.png',
            style: 'height:40px;'
        },
        logoname: {
            ligth: 'layout/collabe/images/logo-nome-light.png',
            dark: 'layout/collabe/images/logo-nome-dark.png',
            style: 'height:40px;'
        }
    },
    theme: {
        colorScheme: 'light',
        menu: 'green',
        component: 'green',
        menuMode: 'horizontal'
    },
    opcoes: {
        powerbi: {
            desabilitarSalvamentoAutomatico: true
        }
    },
    sifm: true
};

export default AppConfigDefs;